/**
 * Created by anthony on 7/7/14.
 */
/**
 * Created by anthony on 7/7/14.
 */
var standardCudArrayFactory = angular.module('standardCudArray', ['classy']);
standardCudArrayFactory.factory('standardCudArrayFactory', function(StandardCudFactory)
{
    var standardCudArrayFactory = function(model, id, item, ctrl, dirtyVars)
    {
        StandardCudFactory.apply(this, arguments);
        this.editItem = [];
    };

    standardCudArrayFactory.prototype = new StandardCudFactory();
    standardCudArrayFactory.prototype.parent = StandardCudFactory.prototype;
    standardCudArrayFactory.prototype.startSaveProcess = function(scope, instance, form)
    {
        if (form.$valid)
        {
            instance.options.factor  = .3;
            return this.model.putMultiple(this.id, this.controller.$.items, instance)
        }
        else
        {
            instance.stop(-1);
        }
    }

    standardCudArrayFactory.prototype.successSave = function (scope, instance, verboseReturn)
    {
        if (verboseReturn == true)
        {
            this.model.set(instance.options.data);
            this.controller.$.items = angular.copy(this.model.get());
        }
        else
        {
            this.model.set(this.controller.$.items);
        }
        this.updateCopy();
        this.editItem = [];
        var self = this;
        setTimeout(function() {
            self.controller.$.$apply();
        }, 400)
    }

    standardCudArrayFactory.prototype.add = function()
    {
        this.editItem[this.controller.$.items.length] = true;
        this.controller.$.items.push(this.model.new());

    }

    standardCudArrayFactory.prototype.del = function(index)
    {
        if (typeof this.controller.$.items[index].recordID !== 'undefined')
        {
            this.controller.$.items[index].showDeleted = 1;
            this.controller.$.items[index].deleted = 1;
            this.toggleEditItem(index);
        }
        else
        {
            this.editItem.pop();
            this.controller.$.items.pop();
        }
    }
    standardCudArrayFactory.prototype.toggleEditItem = function(index)
    {
        this.editItem[index] = !this.editItem[index];
    }
    standardCudArrayFactory.prototype.getEditItem = function(index)
    {
        return this.editItem[index];
    }
    standardCudArrayFactory.prototype.cancelEdit = function()
    {
        this.editItem = [];
        this.model.revertCopy();
        this.controller.$.items = this.model.data;
    }

    return standardCudArrayFactory;
});